import { createSelector } from 'reselect';

import { RootState } from '../types';

const dialogSelector = (state: RootState) => state.dialog;

export const currentDialogSelector = createSelector(
  dialogSelector,
  (dialog) => dialog.currentDialog
);

export const dialogDataSelector = createSelector(
  dialogSelector,
  (dialog) => dialog.currentDialog?.data
);

export const dialogNameSelector = createSelector(
  dialogSelector,
  (dialog) => dialog.currentDialog?.name
);
